export const SIGN_IN = '/';
export const PASSWORD_FORGET = '/pw-forget';
export const HOME = '/employeeList';
export const ACCOUNT = '/account';
export const ADD_EMPLOYEE = '/addEmployee';
